import React from 'react';

const SectionHeader = ({ eyebrow, title, description, className = "" }) => (
  <div className={`mx-auto max-w-2xl min-w-0 text-center px-0 ${className}`}>
    <h2 className="text-[10px] font-semibold uppercase tracking-[0.12em] text-primary-700 xs:text-[11px] xs:tracking-[0.14em] sm:text-xs sm:tracking-[0.18em]">
      {eyebrow}
    </h2>
    <p className="mt-2 break-words text-2xl font-heading font-bold leading-tight tracking-tight text-charcoal-900 xs:mt-3 xs:text-[1.75rem] sm:text-4xl lg:text-5xl">
      {title}
    </p>
    {description && (
      <p className="mt-3 break-words text-sm leading-6 text-charcoal-600 xs:mt-4 xs:text-base sm:text-lg sm:leading-8">
        {description}
      </p>
    )}
  </div>
);

export default SectionHeader; 